import { DraftReturnSchema } from "@redotech/redo-model/draft-return/draft-return";
import { zExt } from "@redotech/rpc/ext";
import { z } from "zod";

export const skipAddReturnItems = {
  input: z.object({ draftReturnId: zExt.objectId() }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
